import { render, staticRenderFns } from "./ValidatePersonForm.vue?vue&type=template&id=94f4d6ae&scoped=true"
import script from "./ValidatePersonForm.vue?vue&type=script&lang=js"
export * from "./ValidatePersonForm.vue?vue&type=script&lang=js"
import style0 from "./ValidatePersonForm.vue?vue&type=style&index=0&id=94f4d6ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f4d6ae",
  null
  
)

/* custom blocks */
import block0 from "./ValidatePersonForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports